import { useTranslation } from 'react-i18next';

interface ViewToggleProps {
  viewMode: 'grid' | 'list';
  onChange: (mode: 'grid' | 'list') => void;
}

export default function ViewToggle({ viewMode, onChange }: ViewToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center bg-background-100 rounded-lg p-0.5 gap-0.5">
      <button
        onClick={() => onChange('grid')}
        className={`flex items-center justify-center gap-1.5 px-3 py-2 rounded-md text-sm transition-all duration-200 active:scale-95 cursor-pointer ${
          viewMode === 'grid'
            ? 'bg-background-50 text-foreground-950 shadow-sm'
            : 'text-foreground-500 hover:text-foreground-700'
        }`}
        title={t('view.grid')}
        aria-label={t('view.grid')}
        aria-pressed={viewMode === 'grid'}
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-layout-grid-line" />
        </span>
        <span className="hidden md:inline text-xs">{t('view.grid')}</span>
      </button>
      <button
        onClick={() => onChange('list')}
        className={`flex items-center justify-center gap-1.5 px-3 py-2 rounded-md text-sm transition-all duration-200 active:scale-95 cursor-pointer ${
          viewMode === 'list'
            ? 'bg-background-50 text-foreground-950 shadow-sm'
            : 'text-foreground-500 hover:text-foreground-700'
        }`}
        title={t('view.list')}
        aria-label={t('view.list')}
        aria-pressed={viewMode === 'list'}
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-list-unordered" />
        </span>
        <span className="hidden md:inline text-xs">{t('view.list')}</span>
      </button>
    </div>
  );
}